module.exports = __webpack_public_path__ + "static/6305-woodrose-58-1051b528b3923da3b37568d78a3b86f2.jpg";